export const APP_INITIALIZATION = 'APP_INITIALIZATION';
export const appInitialization = (dispatch, initialData) => ({
  type: APP_INITIALIZATION,
  dispatch,
  initialData,
});
